"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var Ring = /** @class */ (function (_super) {
    tslib_1.__extends(Ring, _super);
    function Ring() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ring.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'ring';
        _super.prototype.createLayers.call(this, layerProps);
    };
    Ring.getDefaultOptions = layer_1.default.getDefaultOptions;
    return Ring;
}(plot_1.default));
exports.default = Ring;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/ring/index.js
// module id = 967
// module chunks = 37